import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cn } from "@/lib/utils"

// Variantes y tamaños explícitos: antes `size` se ignoraba y los botones
// quedaban sin padding salvo que cada pantalla lo pusiera a mano.
const VARIANTS = {
    default: "bg-primary text-primary-foreground hover:bg-primary/90",
    outline: "border border-input bg-white/5 text-white hover:bg-white/10",
    ghost: "bg-transparent text-white/70 hover:bg-accent hover:text-accent-foreground",
    secondary: "bg-secondary text-secondary-foreground hover:bg-white/15",
    destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
    link: "bg-transparent text-blue-400 underline-offset-4 hover:underline",
}

const SIZES = {
    default: "h-10 px-4 py-2",
    sm: "h-9 px-3",
    lg: "h-11 px-6",
    icon: "h-10 w-10 p-0",
}

const Button = React.forwardRef(({ className, variant = "default", size = "default", asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button"
    return (
        <Comp
            className={cn(
                "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors cursor-pointer",
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ring-offset-background",
                "disabled:pointer-events-none disabled:opacity-50 [&_svg]:shrink-0",
                VARIANTS[variant] ?? VARIANTS.default,
                SIZES[size] ?? SIZES.default,
                className
            )}
            ref={ref}
            {...props}
        />
    )
})
Button.displayName = "Button"

export { Button }
